import { fromEvent } from "rxjs";
import { filter, map } from "rxjs/operators";

type IframeMessageType = "method" | "event" | "route" | "ajax";

export type IframeMessage = {
  type: IframeMessageType;
  name: string;
  args: Array<unknown>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  source: "ebooking" | "hotel";
};

export const iframeMessage$ = fromEvent<MessageEvent<IframeMessage>>(
  window,
  "message"
).pipe(filter((x) => !!(x.data.type && x.data.name)));

export const iframeClick$ = iframeMessage$
  .pipe(map((x) => x.data as IframeMessage))
  .pipe(filter((x) => x.type === "event" && x.name === "click"));
